import { createContext } from 'react';
import { BackendUser as User, BackendSession as Session } from '@/infrastructure/clients/BackendClient';

interface AuthContextType {
  user: User | null;
  session: Session | null;
  loading: boolean;
  refreshUser: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  session: null,
  loading: true,
  refreshUser: async () => {}
});
